<template>
  <div style="overflow-x: hidden;background-color: white;position: absolute;left: 0;right: 0;top: 0" class="bg">
    <Navigator/>
    <SliderBanner :slider="slider"/>
    <FuncShow :funInfo="funInfo" style="background: #F4F7FF; ">
    </FuncShow>
    <Footer/>
    <ContactFloat/>
  </div>
</template>

<script>
import Navigator from '../widgets/navigator'
import Footer from '../widgets/footer'
import SliderBanner from '../widgets/SliderBanner'
import FuncShow from '../widgets/func-show'
import ContactFloat from '../widgets/contact-float.vue'

export default {
  components: {
    Navigator,
    FuncShow,
    ContactFloat,
    SliderBanner,
    Footer
  },
  data() {
    return {
      slider: {
        image: require('@/assets/images/index/short-play/phone.png'),
        title: '短剧板块',
        desc: "短剧CPS海量优质短剧资源 自带流量 支持三大平台推流(抖音,快手,视频号) 佣金高达90%"
      },
      funInfo: {
        title: '短剧板块',
        list: [
          {
            title: '短剧推广',
            img: require('@/assets/images/index/short-play/img2.png'),
            text: '这里有抖音/快手短剧，只需要复制推广链接，创建推广\n' +
                '即可完成分享，赚取佣金'
          },
          {
            title: '佣金榜单排名',
            img: require('@/assets/images/index/short-play/img3.png'),
            text: '用户可以看到当日、昨日、7天、12天内的短剧推广赚取的佣金排行情况'
          },
          {
            title: '任务推广计划',
            img: require('@/assets/images/index/short-play/img4.png'),
            text: '与抖音、快手平台合作千分任务，一键赚取双平台收益'
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
